import type { StateGS } from "./StateGS";

export enum StateRunResultEnum {
    /** State successfully activated. */
    Activated,
    /** State activation failed. */
    Failed,
    /** State was not activated because control was passed elsewhere. */
    Skipped
}

export enum StateRunModeEnum {
    ServerRender,
    BrowserFromServer,
    BrowserTransition
}

export interface StateConstructor {
    new(): StateGS;
    readonly StateName: string;
    readonly IsPrivate: boolean;
    readonly Instance?: StateGS;
}

/** Available only inside the callback passed to StateGS.Configure. */
export interface StateSetupGS {
    UsePathRouting: boolean;
    DefaultStateName: string;
    State404Name: string;
    RegState(constructor: StateConstructor): void;
    ReplaceState(constructor: StateConstructor): void;
}
